import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';

interface ProductWeight {
	membershipNo: string;
}

export interface FcpContractorDetails {
	name: string;
	ytd_banking: null | number;
}
export interface FpcDetails {
	data: FcpContractorDetails[];
}

interface IRecommendedProductsResponse {
	mutate: UseMutateFunction<FpcDetails, Error, ProductWeight, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useFetchFpcDetails = (): IRecommendedProductsResponse => {
	const fetchContractorFPCList = async (params: ProductWeight): Promise<FpcDetails> => {
		return APIService.getData<FpcDetails>(`${APICONFIG.GET_CONTRACTORS_FPC_LIST}?membership_no=${params.membershipNo}`);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: fetchContractorFPCList,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
